export type TemplateLanguageMap = { [language: string]: TemplateLanguage };

export class TemplateLanguage {
  description?: string;
  html: string;
  mjml: string;
  name: string;
  previewImageUrl: string;
  subject: string;

  constructor(obj?: any) {
    if (obj) Object.assign(this, obj);
  }
}

export class Template {
  createdFromTemplateId?: string;
  custId?: string;
  id: string = null;
  languageDefinitionMap: TemplateLanguageMap;
  messageTypeId: number;
  transactionTypeId: number;
  version: number = null;
  selectedLanguage?: string = null;

  constructor(obj?: any) {
    if (obj) Object.assign(this, obj);
  }
}
